var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useState } from "react";
import { memo } from "react";
import { AVATAR, AVATAR_IMAGE, AVATAR_LABEL } from "../../classConstants";
import { getClassName } from "../../helpers";
import styled from "styled-components";
// / convert words into array of chars to handle words that contain surrogate pairs e.g. "👨‍👩‍👧‍👦", "🐶".
var extractFirstAndSecondWordArrays = function (text) {
    var _a = text.trim()
        .split(' ')
        .splice(0, 2)
        .map(function (word) { return Array.from(word !== null && word !== void 0 ? word : ''); }), firstWord = _a[0], _b = _a[1], secondWord = _b === void 0 ? [] : _b;
    return {
        firstWord: firstWord,
        secondWord: secondWord,
    };
};
export var Avatar = styled(memo(function (props) {
    var _a;
    if (!props.label.trim())
        return null;
    var _b = useState(false), didImageError = _b[0], setDidImageError = _b[1];
    var _c = useState({}), imageDimensions = _c[0], setImageDimensions = _c[1];
    var url = props.url, label = props.label;
    var handleImageError = useCallback(function () {
        setDidImageError(true);
    }, []);
    var handleImageSuccess = useCallback(function (e) {
        var _a = e.target, naturalHeight = _a.naturalHeight, naturalWidth = _a.naturalWidth, height = _a.height, width = _a.width;
        setImageDimensions(naturalWidth > naturalHeight
            ? { height: width, }
            : { width: height, });
    }, []);
    var renderAvatarCharacters = function () {
        var _a = extractFirstAndSecondWordArrays(label), firstWord = _a.firstWord, secondWord = _a.secondWord;
        return "" + (firstWord[0] || '') + (secondWord[0] || firstWord[1] || '');
    };
    var renderAvatar = function () {
        if (!url || didImageError)
            return renderAvatarCharacters();
        return React.createElement(AvatarImage, __assign({}, imageDimensions, { className: AVATAR_IMAGE, onLoad: handleImageSuccess, onError: handleImageError, src: url }));
    };
    var avatarClassName = getClassName(props.className, AVATAR, (_a = {}, _a[AVATAR_LABEL] = !url || didImageError, _a));
    return (React.createElement("span", { className: avatarClassName }, renderAvatar()));
}))(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-flex;\n    height: var(--ws-avatar-size, 2em);\n    width: var(--ws-avatar-size, 2em);\n    line-height: var(--ws-avatar-size, 2em);\n    font-size: var(--ws-avatar-font-size, .75em);\n    border-radius: var(--ws-avatar-border-radius, 50%);\n    box-shadow: var(--ws-avatar-box-shadow);\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    &.", " {\n        background-color:var(--ws-avatar-bg-color);\n        color:var(--ws-avatar-bg-color-contrast);\n    }\n"], ["\n    display: inline-flex;\n    height: var(--ws-avatar-size, 2em);\n    width: var(--ws-avatar-size, 2em);\n    line-height: var(--ws-avatar-size, 2em);\n    font-size: var(--ws-avatar-font-size, .75em);\n    border-radius: var(--ws-avatar-border-radius, 50%);\n    box-shadow: var(--ws-avatar-box-shadow);\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    &.", " {\n        background-color:var(--ws-avatar-bg-color);\n        color:var(--ws-avatar-bg-color-contrast);\n    }\n"])), AVATAR_LABEL);
var AvatarImage = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n"], ["\n    ",
    "\n"])), function (props) {
    var _a, _b;
    return (_b = (_a = props.height) !== null && _a !== void 0 ? _a : props.width) !== null && _b !== void 0 ? _b : "\n        max-width: 100%;\n        max-height: 100%;\n    ";
});
var templateObject_1, templateObject_2;
